import { createAction, props } from "@ngrx/store";

export const optOut = createAction(
    '[eAuth] Opted out',
);

export const optIn = createAction(
    '[eAuth] Opted in',
);

export const accountHolderSelected = createAction(
    '[eAuth] Account holder selected',
    props<{ accountHolder: string[] }>()
);

export const invalidSubmitClick = createAction(
    '[eAuth] Submit clicked with eAuth in invalid state',
);

export const missingEmailAddressSubmitClick = createAction(
  '[eAuth] Submit clicked with eAuth account holder missing email address'
);

export const generateLoaPdf = createAction(
  '[eAuth] Generate LOA PDF',
);

export const eAuthTableDisplay = createAction(
  '[Create Request - eAuth] eAuth table interface updated',
  props<{ userInputRequired: boolean }>()
);
